import { render } from "./CloseAccount.vue?vue&type=template&id=59083c33&scoped=true"
import script from "./CloseAccount.vue?vue&type=script&lang=js"
export * from "./CloseAccount.vue?vue&type=script&lang=js"

import "./CloseAccount.vue?vue&type=style&index=0&id=59083c33&scoped=true&lang=css"

import exportComponent from "C:\\src\\Vue Project\\inalife-admin-dashboard\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59083c33"]])

export default __exports__